// extracted by mini-css-extract-plugin
export default {"analyticsContentWrapper":"styles_analyticsContentWrapper__jKlYC","welcomeText":"styles_welcomeText__wb3xR"};